import {actions as A} from '../constants/actions';

const defaultState = {
  list: null,
  statistics: null,
  page: 0,
  totalPages: 0,
  totalResultCount: 0,
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_INSPECTIONS_BY_SHARED_LIST:
      return {...state, loading: true, error: false, errorMessage: null};

    case A.GET_INSPECTIONS_BY_SHARED_LIST_SUCCESS:
      const {list, statistics, totalPages, totalResultCount} = payload;
      return {...state, loading: false, error: false, errorMessage: null, list, statistics, totalPages, totalResultCount};

    case A.SET_INSPECTIONS_BY_SHARED_PAGE:
      const {page} = payload;
      return {...state, loading: false, error: false, errorMessage: null, page};

    case A.GET_INSPECTIONS_BY_SHARED_LIST_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    default:
      return state;
  }
}

